import { Tooltip, Typography } from "antd";
import { CheckOutlined } from '@ant-design/icons';
import moment from "moment";
const { Text } = Typography;
export const CorrelationIdHandler = ({ data, handleCopy, copied }) => {
    const correlationId = data?.correlationId;
    const shortAddress = `${correlationId.substring(0, 8)}....${correlationId.substring(correlationId?.length - 8)}`
    return (
        <div>
            {!correlationId && <div className='text-white flex-space-between'> -- </div>}
            {correlationId && copied !== data?.id &&
                <Text key={data?.id} className="text-white flex-space-between" copyable={{ text: correlationId, onCopy: handleCopy(data?.id) }} options={{ format: 'text/plain' }} >
                    <span>{shortAddress}</span>
                </Text>}
            {copied === data?.id &&
                <Text className="text-white ms-2 flex-space-between" key={data?.id}>
                    <span>{shortAddress}</span>
                    <Tooltip title="Copied" open={copied}>
                        <CheckOutlined style={{ marginLeft: 8, color: 'green' }} />
                    </Tooltip>
                </Text>}
        </div>
    );
}

export const DateColumnHandler = ({data}) => {
    const date=(data?.dataItem?.creationTime);
    return (
        <div>
            <div className="gridLink">
                {date ? <> {moment.utc(date).local().format("DD/MM/YYYY hh:mm:ss A")}</> : date}
            </div>           
        </div>
    )
}